<mat-card
  appearance="outlined"
  [ngClass]="{'light-bg-blue': editModeEnabled, 'section-card': !disableOverflow}"
>
  <mat-card-title class="section-card__title bg-white">
    <span class="section-card__title-heading">
      {{ heading | translate }}
    </span>

    @if (showEditButton) {
      @if (!editModeEnabled) {
        <button
          mat-button
          type="button"
          color="primary"
          class="density--3"
          (click)="handleToggleEditMode()"
          [disabled]="anyOtherSectionInEditMode"
        >
          <span>
            {{ 'TRANS__PROFILE__EDIT_SECTION' | translate }}
          </span>
        </button>
      }

      <div class="section-card__add-button">
        @if (name === 'collections') {
          <button
            mat-button
            type="button"
            class="density--3"
            [disabled]="editModeEnabled"
            (click)="addCollectionRights(name)"
          >
            <span>
              {{ 'TRANS__PROFILE__ADD_COLLECTION_RIGHTS' | translate }}
            </span>
          </button>
        }
        @else if (name === 'virtual_collections') {
          <button
            mat-button
            type="button"
            class="density--3"
            [disabled]="editModeEnabled"
            (click)="addCollectionRights(name)"
          >
            <span>
              {{ 'TRANS__PROFILE__ADD_VIRTUAL_COLLECTION_RIGHTS' | translate }}
            </span>
          </button>
        }
      </div>
    }
  </mat-card-title>

  <mat-card-content class="section-card__content bg-white">
    <ng-content></ng-content>
  </mat-card-content>

  @if (editModeEnabled) {
    <mat-card-actions class="button-container bg-white">
      <button
        mat-flat-button
        class="button-container__button density--3"
        color="primary"
        type="button"
        (click)="handleSaveAndAbort(saveClicked)"
      >
        <span class="bold uppercase">
          {{ 'TRANS__PROFILE__SAVE_BUTTON_LABEL' | translate }}
        </span>
      </button>

      <button
        mat-button
        class="button-container__button density--3"
        color="primary"
        type="button"
        (click)="handleSaveAndAbort(abortClicked)"
      >
        <span class="text-dark-primary bold uppercase">
          {{ 'TRANS__PROFILE__CANCEL_BUTTON_LABEL' | translate }}
        </span>
      </button>
    </mat-card-actions>
  }
</mat-card>
